module.exports = __webpack_public_path__ + "static/media/ServiceLandingImages2.621c3228.svg";